import styled from "styled-components";

import { theme } from "../../themes/themes";
import { theme as themeConfig } from "../../themes/themes";
export const ContentCalendar = styled.div`
  height: ${(props) => (props.height ? props.height : "100%")};
  .rbc-time-header {
    margin-right: 3px !important;
  }
  .rbc-toolbar-label {
    font-weight: 700;
  }
  .rbc-time-content::-webkit-scrollbar {
    width: 0.3em;
  }

  .rbc-time-content::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.button.primary};
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  .rbc-time-content::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
`;
export const TooltipState = styled.div`
  height: 1em;
  width: 1em;
  background: ${(props) => (props.color ? props.color : theme.button.primary)};
  border-radius: 5px;
  margin-top: 2px;
`;
export const ContentTooltip = styled.div`
  display: grid;
  grid-template-columns: 1em 1fr;
  grid-gap: 5px;
  height: auto;
  padding: 0.5em;

  span {
    font-weight: 600;
    font-size: 23px;
    display: flex;
    color: ${({ theme }) => theme.button.primary};
  }
  label {
    color: #737373;
    font-size: 11px;
    margin: 0 5px;
  }
`;
export const StatusEvent = styled.div`
  color: ${(props) => (props.status === "Accept" ? themeConfig.primary.greenDark : themeConfig.status.error)};
  float: right;
`;
